import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { RegisterService } from 'src/app/core/services/register/register.service';
import { RoutesKeys } from 'src/app/utils/routes';

@Injectable({
  providedIn: 'root',
})
/**
 * Expired Invite Guard
 */
export class ExpiredInviteGuard implements CanActivate {
  /**
   * @constructor
   */
  constructor(
    private readonly registerService: RegisterService,
    private readonly router: Router
  ) {}

  /**
   * Can activate
   * @return {boolean}
   */
  canActivate(): boolean | UrlTree {
    if (this.registerService.routingGuards.expiredInvite) {
      return true;
    }
    return this.router.parseUrl(RoutesKeys.HOME);
  }
}
